/**
 * POSTCARD NOTE SYNC
 *
 * Mirrors the postcard's personal message ("Personlig Besked" line item
 * property) into the order Note (cart.note) so the warehouse can see what to
 * print on the card.
 *
 * Why this exists: the postcard widget stores the customer's greeting as a line
 * item property only, and the manual cart-note textarea is intentionally hidden
 * when a postcard is in the cart (see main-cart.liquid / cart-drawer.liquid:
 * "postcard uses cart.note for message"). Without this sync the order Note stays
 * empty. Loaded globally via js-variables.liquid so it runs on initial page load
 * (covering carts that already contain a postcard) and on every cart change.
 *
 * Only one postcard is ever allowed in the cart, so a single cart-level note is
 * safe. When the postcard is removed we clear the note again, but only if it
 * still holds the exact message we wrote — a customer's own order note (typed on
 * a cart without a postcard) is never touched.
 */
(function () {
  'use strict';

  if (window.__postcardNoteSyncInit) return;
  window.__postcardNoteSyncInit = true;

  var PROP_FLAG = '_postcard';
  var PROP_MESSAGE = 'Personlig Besked';
  var lastSynced = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // Returns the postcard's message string, or null if no postcard is in the cart.
  function findPostcardMessage(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var props = items[i].properties || {};
      if (props[PROP_FLAG] === 'true' || props[PROP_FLAG] === true) {
        var raw = props[PROP_MESSAGE];
        return raw != null ? String(raw) : '';
      }
    }
    return null;
  }

  function updateNote(note) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ note: note })
    });
  }

  async function syncFromCart(cart) {
    try {
      var c = cart;
      if (!c) {
        var res = await fetch(root() + 'cart.js', {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          cache: 'no-store'
        });
        if (!res.ok) return;
        c = await res.json();
      }

      var message = findPostcardMessage(c);
      var currentNote = c.note || '';

      // No postcard in the cart: clear the note, but ONLY if it still holds the
      // postcard message we previously wrote — never clobber a customer's own note.
      if (message == null) {
        if (currentNote !== '' && currentNote === lastSynced) {
          lastSynced = null;
          await updateNote('');
        }
        return;
      }

      // Postcard present but no message written yet — leave the note untouched.
      if (message.trim().length === 0) return;

      // Remember the message so we can recognise (and later clear) it.
      lastSynced = message;

      // Skip redundant writes.
      if (currentNote === message) return;

      await updateNote(message);
    } catch (err) {
      console.error('[Postcard note sync] failed to sync message to cart note', err);
    }
  }

  // Initial load — covers carts that already contain a postcard.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncFromCart(); });
  } else {
    syncFromCart();
  }

  // Every cart change — covers add-to-cart, inline message edit, and cross-sell.
  document.documentElement.addEventListener('cart:change', function (event) {
    var cart = event && event.detail && event.detail.cart;
    syncFromCart(cart);
  });
})();
